import type { calendar as EN } from '../en/calendar';

export const calendar: Record<keyof typeof EN, string> = {
  'calendar.header.previous': 'Zurück',
  'calendar.header.next': 'Weiter',
  'calendar.header.today': 'Heute',
  'calendar.event.noCategory': 'Keine Kategorie',
  'calendar.event.startTime': 'Startzeit',
  'calendar.event.endTime': 'Endzeit',

  // CalendarHeader
  'calendar.nav.label': 'Kalenderansichten',
  'calendar.tabs.agenda': 'Agenda',
  'calendar.tabs.week': 'Woche',
  'calendar.tabs.month': 'Monat',
  'calendar.event.new': 'Neuer Termin',

  // EventDialog
  'calendar.event.edit': 'Termin bearbeiten',
  'calendar.event.titleLabel': 'Titel',
  'calendar.event.titlePlaceholder': 'Den Gildenmeister treffen',
  'calendar.event.allDay': 'Ganztägig',
  'calendar.event.start': 'Start',
  'calendar.event.end': 'Ende',
  'calendar.event.clearEnd': 'Ende entfernen',
  'calendar.event.noEndTitle': 'Kein Ende',
  'calendar.event.addEnd': 'Kein Ende — eins hinzufügen',
  'calendar.event.endError': 'Das Ende muss nach dem Start liegen.',
  'calendar.event.runsThrough': 'Läuft bis einschließlich {date}.',
  'calendar.event.categoryLabel': 'Kategorie',
  'calendar.event.descriptionLabel': 'Beschreibung',
  'calendar.event.pagesLabel': 'Seiten',
  'calendar.event.unlinkPage': '{title} entfernen',
  'calendar.event.linkPage': 'Seite verknüpfen',
  'calendar.event.searchPages': 'Seiten durchsuchen…',
  'calendar.event.noPagesMatch': 'Keine Seiten für „{query}“.',
  'calendar.event.doneLabel': 'Erledigt',
  'calendar.event.doneSuffix': ' (erledigt)',
  'calendar.event.discardTitle': 'Diesen Termin verwerfen?',
  'calendar.event.discardDescription':
    'Du hast ungespeicherte Änderungen. Wenn du jetzt schließt, gehen sie verloren.',
  'calendar.event.keepEditing': 'Weiter bearbeiten',
  'calendar.event.discard': 'Verwerfen',
  'calendar.event.deleteTitle': '„{title}“ löschen?',
  'calendar.event.deleteFallbackTitle': 'diesen Termin',
  'calendar.event.deleteDescription':
    'Termine werden endgültig gelöscht — es gibt keinen Termin-Papierkorb. Verknüpfte Seiten bleiben unberührt.',
  'calendar.event.fallbackLabel': 'Termin',

  // Agenda
  'calendar.agenda.title': 'Nächste {days} Tage',
  'calendar.agenda.overdueLabel': 'Überfällig',
  'calendar.agenda.overdueHeading': 'Überfällig ({count})',
  'calendar.agenda.emptyState': 'Für die nächsten 7 Tage ist nichts geplant.',
  'calendar.agenda.today': 'Heute ·',
  'calendar.agenda.newEventOn': 'Neuer Termin am {date}',
  'calendar.agenda.markDone': '„{title}“ als erledigt markieren',
  'calendar.agenda.markNotDone': '„{title}“ als nicht erledigt markieren',
  'calendar.agenda.allDay': 'ganztägig',
  'calendar.agenda.dayOfSpan': 'Tag {day} von {span}',

  // WeekView
  'calendar.week.newEventAria': 'Neuer Termin am {date} — Stunde klicken oder Zeitraum ziehen',

  // MonthView
  'calendar.month.more': '+{count} weitere',

  // DueDate / DueDateForm
  'calendar.due.setPrompt': 'Fälligkeitsdatum setzen',
  'calendar.dueOn': 'Fällig {date}',
  'calendar.due.buttonLabel': 'Fälligkeitsdatum',
  'calendar.due.time': 'Fälligkeitszeit',
  'calendar.due.clear': 'Entfernen',
  'calendar.due.fallbackLabel': 'Fälligkeitsdatum',
  'calendar.due.titlePrefix': 'Fällig: {title}',

  // EventLinksPanel
  'calendar.links.ariaLabel': 'Referenziert von Terminen',
  'calendar.links.referencedBy.one': 'Referenziert von {count} Termin',
  'calendar.links.referencedBy.other': 'Referenziert von {count} Terminen',
  'calendar.links.openAgenda': 'Agenda öffnen',

  // Category (useEventCategories.ts)
  'calendar.category.fallbackLabel': 'Kategorie',

  // Toasts
  'calendar.toast.createError': 'Der Termin konnte nicht erstellt werden.',
  'calendar.toast.updateError': 'Der Termin konnte nicht gespeichert werden.',
  'calendar.toast.deleteError': 'Der Termin konnte nicht gelöscht werden.',
  'calendar.toast.toggleError': 'Der Termin konnte nicht aktualisiert werden.',
  'calendar.toast.dueError': 'Das Fälligkeitsdatum konnte nicht gesetzt werden.',
  'calendar.toast.categoryCreateError': 'Die Kategorie konnte nicht erstellt werden.',
  'calendar.toast.categoryUpdateError': 'Die Kategorie konnte nicht gespeichert werden.',
  'calendar.toast.categoryDeleteError': 'Die Kategorie konnte nicht gelöscht werden.',
};
